<template>
  <div class="columns is-centered">
    <div id="checkout" class="column"></div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutForm',
  data() {
    return {
      stripe: null,
      checkout: null,
      clientSecret: null
    };
  },
  async mounted() {
    if (!sessionStorage.getItem('reloaded')) {
      sessionStorage.setItem('reloaded', 'true');
      window.location.reload();
    } else {
      sessionStorage.removeItem('reloaded');

      if (!this.stripe) {
        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_ID);
      }

      this.clientSecret = await this.fetchClientSecret();

      if (this.stripe && !this.checkout && this.clientSecret) {
        this.checkout = await this.stripe.initEmbeddedCheckout({
          clientSecret: this.clientSecret
        });

        // Mount Checkout
        this.checkout.mount('#checkout');
      }
    }
  },
  beforeDestroy() {
    if (this.checkout) {
      this.checkout.unmount();
      this.checkout = null;
    }
  },
  destroyed() {
    if (this.checkout) {
      this.checkout.unmount();
      this.checkout = null;
    }
  },
  methods: {
    async fetchClientSecret() {
      const response = await this.$axios.post(
        this.$API.stripeCheckoutSession(),
        {
          priceId: this.$route.query.price
        }
      );
      const { clientSecret } = response.data;
      return clientSecret;
    }
  }
};
</script>

<style lang="scss" scoped>
figure {
  margin-left: auto;
  margin-right: auto;
}
.tabs {
  margin-top: 15px;
}
.redeem-code {
  margin-bottom: 15px;
}
</style>